import { EEntityType } from '@/editor/types';
import { OperateAbstract } from './OperateAbstract';
import { LinearDimensionEntity } from '@/editor/entities/linearDimensionEntity';
import { ILinearDimension } from '@/editor/data/dimension/dimension';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { Point2dUtils } from '@/editor/math/Point2dUtils';
import { globalStores } from '@/editor/stores';

export class OperateLinearDimension extends OperateAbstract<EEntityType.LinearDimension> {
  private _checkedEntity: LinearDimensionEntity | null = null;
  // 移动开始时的原始数据，移动过程中基于「原始数据 + 位移量」计算，避免累积误差
  private _originDimension: ILinearDimension | null = null;
  private _moved = false;

  get checkedEntity() {
    return this._checkedEntity;
  }

  set checkedEntity(entity: LinearDimensionEntity | null | undefined) {
    this.clear();
    this._checkedEntity = entity ?? null;
  }

  override startMove() {
    if (!this._checkedEntity) return;

    const dimension = globalStores.dimensionStore.getLinearDim(this._checkedEntity.id);
    if (!dimension) return;

    this._originDimension = {
      ...dimension,
      start: Point2dUtils.clone(dimension.start),
      end: Point2dUtils.clone(dimension.end)
    };
  }

  move(point: IPoint2d) {
    if (!this.pickPoint || !this._checkedEntity || !this._originDimension) return;

    this.moving = true;
    this._moved = true;

    const moveVector = Point2dUtils.subtracted(point, this.pickPoint);
    // 实时更新模型，仅做视觉预览，不写入 store（避免移动过程产生大量历史记录）
    this._checkedEntity.update(this._getMovedDimension(this._originDimension, moveVector));
  }

  completeMove(point: IPoint2d) {
    this.moving = false;

    if (!this.pickPoint || !this._checkedEntity || !this._originDimension || !this._moved) {
      this.clear();
      return;
    }

    // 移动结束时一次性提交数据，写入历史记录（_refresh 内部会重新渲染选中态）
    const moveVector = Point2dUtils.subtracted(point, this.pickPoint);
    const nextDimension = this._getMovedDimension(this._originDimension, moveVector);
    globalStores.dimensionOperation.modifyLinearDimension(nextDimension);

    this.clear();
  }

  // 将起点、终点整体平移，offset 保持不变，使标注随鼠标整体移动
  private _getMovedDimension(origin: ILinearDimension, moveVector: IPoint2d): ILinearDimension {
    return {
      ...origin,
      start: Point2dUtils.added(origin.start, moveVector),
      end: Point2dUtils.added(origin.end, moveVector)
    };
  }

  clear() {
    this._checkedEntity = null;
    this._originDimension = null;
    this._moved = false;
    this.moving = false;
  }

  dispose() {
    this.clear();
  }
}
